/* global axios */
import ApiClient from './ApiClient';

export const buildCompanyParams = (page, sort) => {
  let params = `page=${page}`;
  if (sort) {
    params = `${params}&sort=${sort}`;
  }
  return params;
};

export const buildSearchParams = (query, page, sort) => {
  let params = `q=${encodeURIComponent(query)}&page=${page}`;
  if (sort) {
    params = `${params}&sort=${sort}`;
  }
  return params;
};

class CompanyAPI extends ApiClient {
  constructor() {
    super('companies', { accountScoped: true });
  }

  get(params = {}) {
    const { page = 1, sort = 'name' } = params;
    const requestURL = `${this.url}?${buildCompanyParams(page, sort)}`;
    return axios.get(requestURL);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(companyData) {
    return axios.post(this.url, { company: companyData });
  }

  update(id, companyData) {
    // Check if companyData is FormData (for file uploads)
    if (companyData instanceof FormData) {
      return axios.patch(`${this.url}/${id}`, companyData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return axios.patch(`${this.url}/${id}`, { company: companyData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  search(query = '', page = 1, sort = 'name') {
    const requestURL = `${this.url}/search?${buildSearchParams(query, page, sort)}`;
    return axios.get(requestURL);
  }
}

export default new CompanyAPI();
